import classNames from "classnames";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import React, { Component } from "react";

import Avatar from "./Avatar";

class NotificationSlider extends Component {
    constructor() {
        super();

        this.state = {
            currentIndex: 0,
        };
        this.timerId = null;
        this.timerStarted = false;
        this.resetTimer = this.resetTimer.bind(this);
        this.startTimer = this.startTimer.bind(this);
    }

    componentDidMount() {
        this.startTimer();
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.unreadResponses, this.props.unreadResponses)) {
            this.resetTimer();
        }
    }

    componentDidUpdate() {
        this.startTimer();
    }

    componentWillUnmount() {
        this.resetTimer();
    }

    resetTimer() {
        clearInterval(this.timerId);
        this.setState({ currentIndex: 0 });
        this.timerId = null;
        this.timerStarted = false;
    }

    startTimer() {
        const { unreadResponses } = this.props;

        if (unreadResponses.length > 1 && !this.timerStarted) {
            this.timerId = setInterval(() => {
                const { currentIndex } = this.state;

                if (currentIndex === unreadResponses.length - 1) {
                    this.setState({ currentIndex: 0 });
                } else {
                    this.setState({ currentIndex: currentIndex + 1 });
                }
            }, 3000);
            this.timerStarted = true;
        }
    }

    render() {
        const { currentIndex } = this.state;
        const { latestAnswerForAllResponses, unreadResponses } = this.props;

        const notificationList = unreadResponses.map((response, key) => {
            const notificationClasses = classNames({
                notification: true,
                "is-active": key === currentIndex,
                "is-solo": unreadResponses.length === 1,
            });

            return (
                <div className={notificationClasses} key={response.id}>
                    <h1 className="header-title">
                        <strong>
                            {response.messages.length > 1
                                ? i18n.t("rtm.text.new_reply")
                                : i18n.t("rtm.text.new_answer")}
                        </strong>
                    </h1>
                    <Avatar
                        name={latestAnswerForAllResponses[response.id].author.name}
                        size={26}
                        src={latestAnswerForAllResponses[response.id].author.avatarSrc}
                    />
                </div>
            );
        });

        return <div className="notification-list">{notificationList}</div>;
    }
}

NotificationSlider.propTypes = {
    unreadResponses: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
        })
    ).isRequired,
    latestAnswerForAllResponses: PropTypes.objectOf(
        PropTypes.shape({
            author: PropTypes.shape({
                avatarSrc: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }).isRequired,
        })
    ).isRequired,
};

export default NotificationSlider;
